const dropdownSvg = (
  <svg
    className="drop-icon down"
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    viewBox="0 -960 960 960"
    width="48"
  >
    <path d="M480-348.217 656.522-524 610-569.283l-130 130-130-130L303.978-524 480-348.217Zm.097 269.195q-82.438 0-155.67-31.641-73.232-31.642-127.69-86.199t-86.087-127.62q-31.628-73.064-31.628-155.421 0-83.438 31.641-156.67 31.642-73.232 86.162-127.453 54.519-54.22 127.6-85.706 73.081-31.486 155.458-31.486 83.458 0 156.724 31.599 73.266 31.599 127.463 85.768 54.197 54.17 85.672 127.275 31.476 73.106 31.476 156.512 0 82.471-31.499 155.699-31.499 73.228-85.819 127.657-54.319 54.429-127.382 86.058-73.064 31.628-156.421 31.628Z" />
  </svg>
);

export default dropdownSvg;
